
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forms",
      function () {
        return require("private-next-pages/forms.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forms"])
      });
    }
  